export default __webpack_public_path__ + "static/media/Best-Birthday.51be69b7.jpg";